import { Action, Dispatch } from 'redux'
import { setErrorAction } from 'reducks/modal/actions'

const setError = (error: string) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(setErrorAction(error))
  }
}

export default setError
